<div>
    <strong>{{title}} : </strong>
    {{data}}
    <ng-content></ng-content>
</div>
